import { render } from "./TabbyUI.vue?vue&type=template&id=91ef5f86&scoped=true"
import script from "./TabbyUI.vue?vue&type=script&lang=js"
export * from "./TabbyUI.vue?vue&type=script&lang=js"

import "./TabbyUI.vue?vue&type=style&index=0&id=91ef5f86&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-91ef5f86"

export default script